"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = convertRouteConstraintsToParameters;

var _clone = _interopRequireDefault(require("../../utils/clone"));

function convertRouteConstraintsToParameters(routeWithConstraints, parameters = {}) {
  const matchRoute = (0, _clone.default)(routeWithConstraints, new routeWithConstraints.RouteWithParameters());
  matchRoute.setParameters(parameters);
  return matchRoute;
}